import { render, staticRenderFns } from "./top-logs.vue?vue&type=template&id=4021a100&scoped=true&"
import script from "./top-logs.vue?vue&type=script&lang=js&"
export * from "./top-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021a100",
  null
  
)

export default component.exports